


















import Vue from 'vue'

export default Vue.extend({
  name: 'StyleGuide',
  props: ['component', 'page'],
  computed: {
    styles () {
      return this.page.getDocument()?.model.data.styleGuide
    },
  }
})
